import { motion } from "framer-motion";
import { Sigil } from "./Sigil";

export const Seal = ({ size = 132, label = "INITIATE · UNLOCKED · THE TANTRIC TEMPLE · ", testId = "initiate-seal" }) => (
  <motion.div
    data-testid={testId}
    initial={{ scale: 0.4, opacity: 0, rotate: -90 }}
    animate={{ scale: 1, opacity: 1, rotate: 0 }}
    transition={{ duration: 1.4, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
    className="relative shrink-0"
    style={{ width: size, height: size }}
    aria-label="Initiate — unlocked"
  >
    <svg viewBox="0 0 100 100" className="absolute inset-0 w-full h-full spin-slow">
      <defs>
        <path id="seal-ring" d="M50 50 m-38 0 a38 38 0 1 1 76 0 a38 38 0 1 1 -76 0" />
      </defs>
      <circle cx="50" cy="50" r="48" fill="none" stroke="#D9B47A" strokeWidth="0.6" />
      <circle cx="50" cy="50" r="29" fill="none" stroke="#D9B47A" strokeWidth="0.4" strokeDasharray="1 2" />
      <text fill="#D9B47A" fontSize="6.6" fontFamily="DM Mono, monospace">
        <textPath href="#seal-ring" textLength="236" lengthAdjust="spacing">{label}</textPath>
      </text>
    </svg>
    <div className="absolute inset-[30%] rounded-full bg-[#D9B47A] flex items-center justify-center shadow-[0_0_40px_rgba(217,180,122,0.35)]">
      <Sigil className="w-[70%] h-[70%]" stroke="#0A0706" width={4} />
    </div>
  </motion.div>
);

export const InitiateMark = ({ className = "" }) => (
  <span data-testid="initiate-mark" className={`inline-flex items-center gap-1.5 rounded-full bg-[#D9B47A] text-[#0A0706] pl-1 pr-3 py-0.5 font-tt-mono text-[11px] uppercase tracking-[0.2em] ${className}`}>
    <span className="w-4 h-4 rounded-full bg-[#0A0706] flex items-center justify-center">
      <Sigil className="w-3 h-3" width={6} />
    </span>
    Initiate
  </span>
);
